import { Checkbox, Spin, Form } from 'antd';
import { useState } from 'react';
import { Comment } from '../../models/comment';
import { addComment } from '../../service/comment';
import { createErrorNotification, createSuccessNotification } from '../../service/notification';
import Button from '../Button/Button';
import FormItem from '../FormItem/FormItem';
import styles from './CommentForm.module.scss';
import TextArea from 'antd/lib/input/TextArea';

type Props = Pick< Comment, 'bookId' | 'userId'> 
& {
  refetchData: () => void
}

export const CommentForm = ({ bookId, userId, refetchData }: Props) => {

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isSpoiler, setIsSpoiler] = useState(false); 

  const onFinish = async (payload) => {
    if(loading) return;

    setLoading(true);

    const {error, success} = await addComment({
      isSpoiler: isSpoiler === true ? 1 : 0,
      content: payload.content,
      userId: userId,
      bookId: bookId
    });

    setLoading(false);
      
    if(error) return createErrorNotification(error);
    createSuccessNotification('Comentário postado!');

    setIsSpoiler(false);

    refetchData();
    
    //navigate(`/book/local/${success.id}`);
  }


  return(
    <div className={styles.commentForm}>
      <Form 
        layout="vertical" 
        form={form}
        onFinish={onFinish}
        id="formLogin" 
        className={styles.FormContainer}
      >
        <FormItem name="content">
          <TextArea className={styles.input} placeholder="Comentário..." />
        </FormItem>
        <FormItem>
          <Checkbox checked={isSpoiler} onChange={(event) => {setIsSpoiler(event.target.checked)}}>
            Comentário com spoiler
          </Checkbox>
        </FormItem>
        <Spin spinning={loading}>
          <Button submit style={styles.commentButton}>Comentar</Button>
        </Spin>
      </Form>
    </div>    
  );
}
